module.exports = __webpack_public_path__ + "img/heart.c4c92b01.svg";